import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import { ExternalLink, Newspaper } from "lucide-react";

const images = [
    {
        src: "https://customer-assets.emergentagent.com/job_doctor-mumbai-3d/artifacts/j44uftcm_WhatsApp%20Image%202026-06-24%20at%2011.52.53%20AM.jpeg",
        caption: "With the Hon'ble Vice President of India · Felicitation at Rashtrapati Bhavan",
        span: "md:col-span-7 md:row-span-2",
        h: "h-[480px] md:h-[640px]",
    },
    {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_doctor-mumbai-3d/artifacts/av6vrtee_IMG-20260516-WA0010.jpg",
        caption: "One Rupee Clinic & Railway EMR · At the heart of Mumbai's commute",
        span: "md:col-span-5",
        h: "h-[300px] md:h-[310px]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_doctor-mumbai-3d/artifacts/yehi2wtg_IMG-20260708-WA0005.jpg",
        caption: "Ribbon-cutting inauguration · New clinic branch",
        span: "md:col-span-5",
        h: "h-[300px] md:h-[310px]",
    },
    {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_doctor-mumbai-3d/artifacts/mr25oe5g_IMG-20260520-WA0041.jpg",
        caption: "Inside the Emergency Medical Room · Care at work",
        span: "md:col-span-6",
        h: "h-[360px] md:h-[440px]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_doctor-mumbai-3d/artifacts/ifbtsnou_WhatsApp%20Image%202026-06-24%20at%2011.52.54%20AM%20%281%29.jpeg",
        caption: "India's Most Affordable Healthcare Services · 1 Rupee Clinic",
        span: "md:col-span-6",
        h: "h-[360px] md:h-[440px]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_doctor-mumbai-3d/artifacts/3l8rl0mt_WhatsApp%20Image%202026-06-24%20at%2011.52.51%20AM.jpeg",
        caption: "Operations floor · One Rupee Clinic, Mumbai",
        span: "md:col-span-6",
        h: "h-[300px] md:h-[360px]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_doctor-mumbai-3d/artifacts/oi1x4jv2_WhatsApp%20Image%202026-06-24%20at%2011.52.52%20AM.jpeg",
        caption: "Quality healthcare starts here · Magicdil Group",
        span: "md:col-span-6",
        h: "h-[300px] md:h-[360px]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_doctor-mumbai-3d/artifacts/mte3snsc_WhatsApp%20Image%202026-06-24%20at%2011.52.52%20AM%20%281%29.jpeg",
        caption: "Cultural felicitation · Mumbai chapter",
        span: "md:col-span-6",
        h: "h-[300px] md:h-[360px]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_doctor-mumbai-3d/artifacts/uhgtw5iv_WhatsApp%20Image%202026-06-24%20at%2011.52.50%20AM%20%281%29.jpeg",
        caption: "Inauguration moment · Mumbai division",
        span: "md:col-span-6",
        h: "h-[300px] md:h-[360px]",
    },
];

const press = [
    {
        src: "https://customer-assets.emergentagent.com/job_doctor-mumbai-3d/artifacts/uod725c8_IMG-20260708-WA0003.jpg",
        title: "Our Services & Charges",
        source: "1 Rupee Clinic · India's Most Affordable Healthcare",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_doctor-mumbai-3d/artifacts/peajfqr3_IMG-20260708-WA0009.jpg",
        title: "From today, 40 doctors to offer at-home treatment",
        source: "The Times of India · Mumbai",
    },
];

const TiltCard = ({ img, i, total }) => {
    const ref = useRef(null);
    const [tilt, setTilt] = useState({ rx: 0, ry: 0, s: 1 });

    const onMove = (e) => {
        const rect = ref.current?.getBoundingClientRect();
        if (!rect) return;
        const px = (e.clientX - rect.left) / rect.width;
        const py = (e.clientY - rect.top) / rect.height;
        setTilt({ ry: (px - 0.5) * 14, rx: -(py - 0.5) * 14, s: 1.02 });
    };
    const onLeave = () => setTilt({ rx: 0, ry: 0, s: 1 });

    return (
        <motion.figure
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 1, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
            className={`group ${img.span}`}
            style={{ perspective: "1100px" }}
            data-testid={`gallery-image-${i}`}
        >
            <div
                ref={ref}
                onMouseMove={onMove}
                onMouseLeave={onLeave}
                className="relative overflow-hidden border border-ink-900/10 bg-bisleri-light will-change-transform"
                style={{
                    transform: `rotateX(${tilt.rx}deg) rotateY(${tilt.ry}deg) scale(${tilt.s})`,
                    transformStyle: "preserve-3d",
                    transition: "transform 0.25s cubic-bezier(0.22,1,0.36,1)",
                }}
            >
                <img
                    src={img.src}
                    alt={img.caption}
                    className={`w-full ${img.h} object-cover ${img.pos || ""}`}
                    loading="lazy"
                />
                {/* dynamic glare */}
                <div
                    className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                    style={{
                        background:
                            "linear-gradient(115deg, rgba(255,255,255,0) 35%, rgba(255,255,255,0.28) 50%, rgba(255,255,255,0) 65%)",
                    }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-bisleri/85 via-bisleri/0 to-transparent pointer-events-none" />
                <figcaption
                    className="absolute bottom-4 left-4 right-4 flex items-end justify-between gap-4"
                    style={{ transform: "translateZ(45px)" }}
                >
                    <span className="font-display italic text-base md:text-lg text-white leading-snug drop-shadow-md">
                        {img.caption}
                    </span>
                    <span className="font-mono text-[10px] tracking-[0.25em] text-white/90 drop-shadow-md whitespace-nowrap">
                        {String(i + 1).padStart(2, "0")}/{String(total).padStart(2, "0")}
                    </span>
                </figcaption>
            </div>
        </motion.figure>
    );
};

const Gallery = () => {
    return (
        <section
            id="gallery"
            data-testid="gallery-section"
            className="relative py-24 md:py-32 lg:py-40 bg-sage"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-8 mb-16">
                    <div className="col-span-12 lg:col-span-4">
                        <div className="section-number">08 / Archive</div>
                        <div className="mt-6 divider" />
                        <div className="mt-4 eyebrow">Selected Moments</div>
                    </div>
                    <div className="col-span-12 lg:col-span-8">
                        <motion.h2
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                            className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-ink-900 max-w-3xl"
                        >
                            A decade of <em className="text-bisleri">photographs</em>,
                            and the people inside them.
                        </motion.h2>
                        <p className="mt-5 font-body text-sm text-ink-600">
                            ↳ Hover to tilt each frame.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
                    {images.map((img, i) => (
                        <TiltCard key={i} img={img} i={i} total={images.length} />
                    ))}
                </div>

                {/* In the Press */}
                <div className="mt-24 md:mt-32">
                    <div className="grid grid-cols-12 gap-8 mb-12">
                        <div className="col-span-12 lg:col-span-4">
                            <div className="section-number flex items-center gap-2">
                                <Newspaper size={13} /> In the Press
                            </div>
                            <div className="mt-6 divider" />
                            <div className="mt-4 eyebrow">Coverage & Rate Card</div>
                        </div>
                        <div className="col-span-12 lg:col-span-8">
                            <motion.h3
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                                className="font-display text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-ink-900 max-w-3xl"
                            >
                                Documented in ink — <em className="text-bisleri">the story
                                the city read.</em>
                            </motion.h3>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                        {press.map((p, i) => (
                            <motion.a
                                key={i}
                                href={p.src}
                                target="_blank"
                                rel="noreferrer"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{ duration: 1, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                                className="group relative block overflow-hidden border border-ink-900/10 bg-paper-50"
                                data-testid={`press-item-${i}`}
                            >
                                <div className="flex items-center justify-center p-5 md:p-8 h-[420px] md:h-[560px]">
                                    <img
                                        src={p.src}
                                        alt={p.title}
                                        className="max-h-full max-w-full object-contain shadow-lg shadow-ink-900/10 transition-transform duration-700 group-hover:scale-[1.03]"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="absolute top-4 left-4 inline-flex items-center gap-2 px-3 py-1 bg-white/95 backdrop-blur-sm border border-bisleri/20">
                                    <span className="w-2 h-2 rounded-full bg-clinicgreen animate-pulse" />
                                    <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-bisleri">
                                        {p.source}
                                    </span>
                                </div>
                                <div className="flex items-center justify-between gap-4 px-6 py-5 border-t border-ink-900/10">
                                    <span className="font-display italic text-lg md:text-xl text-ink-900 leading-snug">
                                        {p.title}
                                    </span>
                                    <ExternalLink
                                        size={18}
                                        className="text-ink-500 group-hover:text-bisleri transition-colors shrink-0"
                                    />
                                </div>
                            </motion.a>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Gallery;
